export class ContentFlightTrip {
  upComingTripTitle: string;
  upComingTripUrl: string;
  upComingTripOpenNewWindow: string;
  viewTripDetailsTitle: string;
  viewTripDetailsOpenNewWindow: string;
  checkInTitle: string;
  checkInOpenNewWindow: string;
  viewAllTripsOpenNewWindow: string;
  findMyTripsTitle: string;
  findMyTripsOpenNewWindow: string;
  hotelReservationTitle: string;
  carReservationLabel: string;
  hotelReservationOpenNewWindow: string;
  viewBoardingPassTitle: string;
  viewBoardingPassOpenNewWindow: string;
  viewAllTripsTitle: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['upComingTripTitle']) {
        this.upComingTripTitle = contentjson['upComingTripTitle'];
      }
      if (contentjson['upComingTripUrl']) {
        this.upComingTripUrl = contentjson['upComingTripUrl'];
      }
      if (contentjson['upComingTripOpenNewWindow']) {
        this.upComingTripOpenNewWindow =
          contentjson['upComingTripOpenNewWindow'];
      }
      if (contentjson['viewTripDetailsTitle']) {
        this.viewTripDetailsTitle = contentjson['viewTripDetailsTitle'];
      }
      if (contentjson['viewTripDetailsOpenNewWindow']) {
        this.viewTripDetailsOpenNewWindow =
          contentjson['viewTripDetailsOpenNewWindow'];
      }
      if (contentjson['checkInTitle']) {
        this.checkInTitle = contentjson['checkInTitle'];
      }
      if (contentjson['checkInOpenNewWindow']) {
        this.checkInOpenNewWindow = contentjson['checkInOpenNewWindow'];
      }
      if (contentjson['viewAllTripsOpenNewWindow']) {
        this.viewAllTripsOpenNewWindow =
          contentjson['viewAllTripsOpenNewWindow'];
      }
      if (contentjson['findMyTripsTitle']) {
        this.findMyTripsTitle = contentjson['findMyTripsTitle'];
      }
      if (contentjson['findMyTripsOpenNewWindow']) {
        this.findMyTripsOpenNewWindow = contentjson['findMyTripsOpenNewWindow'];
      }
      if (contentjson['hotelReservationTitle']) {
        this.hotelReservationTitle = contentjson['hotelReservationTitle'];
      }
      if (contentjson['carReservationLabel']) {
        this.carReservationLabel = contentjson['carReservationLabel'];
      }
      if (contentjson['hotelReservationOpenNewWindow']) {
        this.hotelReservationOpenNewWindow =
          contentjson['hotelReservationOpenNewWindow'];
      }
      if (contentjson['viewBoardingPassTitle']) {
        this.viewBoardingPassTitle = contentjson['viewBoardingPassTitle'];
      }
      if (contentjson['viewBoardingPassOpenNewWindow']) {
        this.viewBoardingPassOpenNewWindow =
          contentjson['viewBoardingPassOpenNewWindow'];
      }
      if (contentjson['viewAllTripsTitle']) {
        this.viewAllTripsTitle = contentjson['viewAllTripsTitle'];
      }
    }
  }
}
